// eslint-disable-next-line
import { CONFIG as GENERATED_CONFIG } from '../../generated/config';

export const CONFIG = {
  LD_CLIENT_ID: window.APP_ENV?.LD_CLIENT_ID || '',
  CP_API_URL: GENERATED_CONFIG.CP_API_URL,
  CONTROL_PLANE_ENV: GENERATED_CONFIG.CONTROL_PLANE_ENV,
  GOOGLE_CLIENT_ID: GENERATED_CONFIG.GOOGLE_CLIENT_ID,
  GITHUB_CLIENT_ID: GENERATED_CONFIG.GITHUB_CLIENT_ID,
  STRIPE_PUBLIC_KEY: GENERATED_CONFIG.STRIPE_PUBLIC_KEY,
  STRIPE_PAYMENT_METHOD_CONFIG: GENERATED_CONFIG.STRIPE_PAYMENT_METHOD_CONFIG,
  YEAR: GENERATED_CONFIG.YEAR,
};

export const getBaseUrl = () => {
  if (process.env.NODE_ENV === 'test' && !window.APP_ENV) {
    return process.env.CP_API_URL;
  }
  return CONFIG.CP_API_URL;
};
